import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms/index"

import useListItem from "@molecules/ListItem/ListItem.context"

import styles from "./ListItemActions.module.scss"
import { ListItemActionsProps } from "./ListItemActions.types"

export default function ListItemActions(props: ListItemActionsProps) {
    const { children, showChevron = false } = props

    const { isLoading, isDragging } = useListItem()

    if (isLoading || isDragging) {
        return null
    } else {
        return (
            <div className={styles.base}>
                {children}
                {showChevron && (
                    <div className={styles.chevronWrapper}>
                        <Icon
                            icon={faIcon({ name: "angle-right", style: "regular" })}
                            size={14}
                            container="fixedHeight"
                            className={styles.chevron}
                        />
                    </div>
                )}
            </div>
        )
    }
}
